// extracted by mini-css-extract-plugin
export default {"globalloader1":"Loader_globalloader1__ux77d"};